import React, {
  useRef,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react";
import { getGeneralCategoriesById } from "../../../core/api/Api";
import { useParams } from "react-router-dom";
import FeatureCard from "../../common/feature-card/FeatureCard";
import Loading from "../../common/loading/Loading";
import { useTranslation } from "react-i18next";
import { svgs } from "../../../core/constants/svgs";
import useLangNavigate from "../../common/useLangNavigate";
import { SERVICE_SESSION_ID } from "../../../core/constants/constants";

const GeneralCategories = () => {
  const { t } = useTranslation();
  let { service_id } = useParams();
  const navigate = useLangNavigate();
  const [data, setData] = useState([]);
  const mounted = useRef(true);

  const goToQuestionCategoriesDetails = (item) => () => {
    if (item?.is_active) {
      navigate("/general-categories-options/" + service_id + "/" + item?.id);
    }
  };

  const getData = useCallback(() => {
    getGeneralCategoriesById(service_id)
      .then((res) => {
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setData(data);
        }
      })
      .catch((e) => {});
  }, [service_id]);

  const page_title = useMemo(
    () => t("what_do_you_want_to_write_about") + "?",
    [t]
  );

  const page_description = useMemo(
    () => t("here_you_can_choose_the_kind_of_story_to_write_about"),
    [t]
  );
  const onInit = useRef(true);

  useEffect(() => {
    if (!onInit.current) return;
    onInit.current = false;
    mounted.current = true;
    getData();
    return () => {
      mounted.current = false;
    };
  }, [getData]);

  if (data?.length === 0) {
    return <Loading />;
  }

  const imageMap = {
    [SERVICE_SESSION_ID.IS_ANOTHER_STORY]: svgs.autobiography,
    [SERVICE_SESSION_ID.IS_SELF_DEV]: svgs.writeASelfDev,
    [SERVICE_SESSION_ID.IS_AUTOBIO]: svgs.autobiography,
  };

  console.log("imageMap ", imageMap);

  return (
    <section
      className="aai-features py-100"
      // style={{ background: `url(${bg}) no-repeat center center/cover` }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="aai-section-title mb-3 text-center mb-5">
              <h2 className="section-title">{page_title}</h2>
              <p className="section-desc">{page_description}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {data?.map((item, index) => (
            <FeatureCard
              key={"service-" + index}
              onClick={goToQuestionCategoriesDetails(item)}
              img={imageMap[item.id] ?? null}
              name={item?.name}
              description={item?.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default GeneralCategories;
